import { cn } from "@/core/helpers/cn";

type Props = {
  className?: string;
};

export default function InventorySafeLoader({ className }: Props) {
  return (
    <div className={cn("flex flex-col items-center justify-center shrink-0 w-full", className)}>
      <div className="mz-loader" />
    </div>
  );
}
